import React from "react";

import HexAuthWrapper from "../../components/HexAuthWrapper";
import FinanceRoute from "../../features/finance/FinanceRoute";

const FinancePage = () => (
  <div className="finance-page full-bleed">
    <HexAuthWrapper>
      <FinanceRoute />
    </HexAuthWrapper>
  </div>
);

export default FinancePage;
